import { Crown, Trash2, RotateCcw } from "lucide-react";

const frDate = (iso) => new Date(iso + "T12:00:00").toLocaleDateString("fr-CA", { day: "numeric", month: "long" });

export const DuelCard = ({ d, unit, dw, onDelete, onRematch, saving }) => {
  const [p1, p2] = d.participants;
  const total = p1.volume + p2.volume;
  const pct = total > 0 ? (p1.volume / total) * 100 : 50;
  return (
    <div data-testid={`duel-${d.id}`}
      className={`bg-[#14141A] border p-3 ${d.finished ? "border-[#2E2E3A]" : d.upcoming ? "border-amber-500/40" : "border-[#FF3B30]/30"}`}>
      <div className="flex items-center justify-between">
        <p className="text-white text-sm font-semibold">{d.exercice}</p>
        <div className="flex items-center gap-2">
          <span className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 ${
            d.finished ? "bg-white/10 text-[#B0B0B4]" : d.upcoming ? "bg-amber-500/15 text-amber-400" : "bg-[#FF3B30]/15 text-[#FF3B30]"}`}>
            {d.finished ? "Terminé" : d.upcoming ? `Commence le ${frDate(d.start_date)}` : `${d.days_left} j restants`}
          </span>
          {d.can_delete && (
            <button data-testid={`duel-delete-${d.id}`} onClick={() => onDelete(d.id)}
              className="text-[#B0B0B4] hover:text-[#FF3B30] transition-colors" aria-label="Supprimer">
              <Trash2 size={14} />
            </button>
          )}
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between text-xs">
        {[p1, p2].map((p, i) => (
          <div key={p.id} className={i === 1 ? "text-right" : ""}>
            <p className={`font-semibold flex items-center gap-1 ${i === 1 ? "justify-end" : ""} ${p.is_me ? "text-[#FF3B30]" : "text-white"}`}>
              {d.finished && !d.tie && d.winner_name === p.name && <Crown size={13} className="text-amber-400" />}
              {p.is_me ? "Toi" : p.name}
            </p>
            <p className="text-[#ccc] font-mono">{Math.round(dw(p.volume))} {unit} vol.</p>
            <p className="text-[#B0B0B4] text-[10px]">{p.nb_series} séries · max {p.poids_max ? `${dw(p.poids_max)} ${unit}` : "—"}</p>
          </div>
        ))}
      </div>
      <div className="mt-2 h-[5px] bg-[#14141A] flex overflow-hidden">
        <div className="bg-[#FF3B30] transition-all" style={{ width: `${pct}%` }} />
        <div className="bg-[#ccc] flex-1" />
      </div>
      {d.finished && (
        <div className="mt-2 flex items-center justify-between gap-2">
          <p data-testid={`duel-winner-${d.id}`} className="text-xs flex items-center gap-1.5">
            {d.tie
              ? <span className="text-[#B0B0B4]">Égalité parfaite — revanche ?</span>
              : <><Crown size={13} className="text-amber-400" />
                <span className="text-amber-400 font-semibold">{d.winner_is_me ? "Tu as gagné" : `${d.winner_name} a gagné`} ce duel !</span></>}
          </p>
          {d.participants.some((p) => p.is_me) && (
            <button data-testid={`duel-rematch-${d.id}`} onClick={() => onRematch(d)} disabled={saving}
              className="flex items-center gap-1 text-[10px] uppercase tracking-wider border border-[#FF3B30]/50 text-[#FF3B30] hover:bg-[#FF3B30]/10 px-2 py-1 transition-colors disabled:opacity-30">
              <RotateCcw size={11} /> Revanche
            </button>
          )}
        </div>
      )}
    </div>
  );
};
